export default "__VITE_ASSET__DfkXkc14__"